/* eslint-disable react/prop-types */
import FiatValue from 'components/FiatValue'
import Loader from 'components/Loader'
import { useCharmDepositCap } from 'hooks/useCharmDepositCap'
import { useContext, useMemo } from 'react'
import { ThemeContext } from 'styled-components'
import { ThemedText } from 'theme'
import { Address } from 'viem'

import * as S from './styleds'

export const CharmDepositCapCard: React.FC<{
  poolAddress?: Address
  tvlUSD?: number // Pass the TVL from metrics
}> = ({ poolAddress, tvlUSD }) => {
  const theme = useContext(ThemeContext)
  const { capData, isLoading } = useCharmDepositCap(poolAddress, tvlUSD)

  const utilizationPercentage = useMemo(() => {
    if (!capData || capData.maxCap === 0) return 0
    return (capData.currentDeposits / capData.maxCap) * 100
  }, [capData])

  const getUtilizationColor = (percentage: number) => {
    if (percentage >= 95) return '#ff4747' // Red when very full
    if (percentage >= 80) return '#ff8c00' // Orange when getting full
    return theme.textPrimary
  }

  if (!capData) {
    return null
  }

  if (isLoading) {
    return (
      <S.IslandInfoInnerBox>
        <ThemedText.DeprecatedBody fontSize="14px" fontWeight="500" lineHeight="14px" color={theme.textSecondary}>
          Deposit Cap
        </ThemedText.DeprecatedBody>
        <ThemedText.DeprecatedBody fontSize="20px" fontWeight="400" lineHeight="28px" color={theme.textPrimary}>
          <Loader size="16px" />
        </ThemedText.DeprecatedBody>
      </S.IslandInfoInnerBox>
    )
  }

  if (!capData) {
    return null
  }

  return (
    <S.IslandInfoInnerBox>
      <ThemedText.DeprecatedBody fontSize="14px" fontWeight="500" lineHeight="14px" color={theme.textSecondary}>
        Deposit Cap
      </ThemedText.DeprecatedBody>
      <ThemedText.DeprecatedBody
        fontSize="16px"
        fontWeight="400"
        lineHeight="28px"
        color={getUtilizationColor(utilizationPercentage)}
        style={{
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        }}
      >
        <FiatValue value={capData.currentDeposits} /> / <FiatValue value={capData.maxCap} />
      </ThemedText.DeprecatedBody>
    </S.IslandInfoInnerBox>
  )
}
